import { render, staticRenderFns } from "./add-wiki-category-modal.vue?vue&type=template&id=17e0c404&"
import script from "./add-wiki-category-modal.vue?vue&type=script&lang=ts&"
export * from "./add-wiki-category-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports